export class LeaderBoard {
  constructor(obj) {
    this.rank = obj.rank;
    this.userId = obj.userId;
    this.value = obj.value;
    this.username = obj.username;
    this.flag = obj.flag;
    this.country = obj.country;
  }
  static from(data) {
    if (!data) return null;
    return new LeaderBoard({
      rank: data.rank,
      userId: data.user_id,
      value: data.value,
      username: data.username,
      flag: data.flag,
      country: data.country,
    });
  }
  static fromAll(data) {
    if (!data) return [];
    const results = data.results?.map(LeaderBoard.from);
    const meta = LeaderboardMeta.from(data.meta);
    return { results, meta };
  }
}

export class LeaderboardMeta {
  constructor(obj) {
    this.name = obj.name;
    this.flag = obj.flag;
    this.lastSyncAt = obj.lastSyncAt * 1000;
    this.nextSyncAt = obj.nextSyncAt * 1000;
    this.countryCode = obj.countryCode;
  }

  static from(data) {
    return new LeaderboardMeta({
      name: data.name,
      flag: data.flag,
      lastSyncAt: data.last_sync_at,
      nextSyncAt: data.next_sync_at,
      countryCode: data.iso_alpha_2,
    });
  }

  static fromAll(data) {
    if (!data) return [];
    return data.map(LeaderboardMeta.from);
  }
}
